module.exports = __webpack_public_path__ + "static/media/132.33343d4d.png";